import { Skeleton } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';
import { FLEET_BOARD_GRID_CLASS } from '@/components/fleet/board/fleet-board';

const PLACEHOLDER_COLUMNS = [0, 1, 2, 3] as const;
const PLACEHOLDER_CARDS = [0, 1] as const;

/** The lane names come from the workers' reports, so the skeleton has none to show until the backend answers. */
export function BoardSkeleton() {
  const t = useTranslations('pages.admin.fleet-board');

  return (
    <div className="h-full min-h-0 overflow-auto bg-canvas p-6">
      <div role="group" aria-label={t('columns')} aria-busy="true" className={FLEET_BOARD_GRID_CLASS}>
        {PLACEHOLDER_COLUMNS.map((column) => (
          <section key={column} className="flex min-w-0 flex-col gap-2 rounded-md bg-canvas p-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-5 w-6 rounded-pill" />
            </div>
            {PLACEHOLDER_CARDS.map((card) => (
              <div key={card} className="flex flex-col gap-2 rounded-lg border border-border bg-surface p-3 shadow-sm">
                <Skeleton className="h-4 w-16" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-5 w-20 rounded-pill" />
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
